import { Text, TextProps } from '@shopify/polaris';
import { memo } from 'react';

interface IProps extends Omit<TextProps, 'as'> {
  children: React.ReactNode;
  className?: string;
}

const BoldSmallText = ({ children, ...textProps }: IProps) => {
  return (
    <Text as="span" variant="headingSm" {...textProps}>
      <span className={textProps.className}>{children}</span>
    </Text>
  );
};
export default memo(BoldSmallText);
